"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVSCodeExtensionContext = void 0;
class IVSCodeExtensionContext {
}
exports.IVSCodeExtensionContext = IVSCodeExtensionContext;
//# sourceMappingURL=IVSCodeExtensionContext.js.map